(function () {
  'use strict';
  var ROOT_URL = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

  function number(value, fallback) { var parsed = Number(value); return Number.isFinite(parsed) ? parsed : (fallback || 0); }
  function truthy(value) { return value === true || value === 'true'; }
  function money(cents, currency) {
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'USD', maximumFractionDigits: cents % 100 ? 2 : 0 }).format(cents / 100); }
    catch (error) { return '$' + (cents / 100).toFixed(cents % 100 ? 2 : 0); }
  }
  function unique(values) { return Array.from(new Set(values)); }
  function emit(name, detail) {
    var payload = Object.assign({ event: name, version: 2 }, detail || {});
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    document.dispatchEvent(new CustomEvent(name, { detail: payload }));
  }
  function parseResponse(response) {
    return response.text().then(function (text) {
      var data = {};
      try { data = text ? JSON.parse(text) : {}; } catch (error) { data = { description: text || 'Unreadable response.' }; }
      return { response: response, data: data };
    });
  }
  function fetchCart() {
    return fetch(ROOT_URL + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (response) {
      if (!response.ok) throw new Error('Unable to read the current cart.');
      return response.json();
    });
  }
  function privateProperty(item, key) { return item && item.properties ? item.properties[key] || '' : ''; }
  function cartSignature(item) {
    var plan = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan ? item.selling_plan_allocation.selling_plan.id : item.selling_plan || '';
    return [String(item.variant_id || item.id || ''), String(plan || ''), privateProperty(item, '_ia_meal_source'), privateProperty(item, '_ia_week_build_id')].join('|');
  }
  function requestSignature(item) {
    return [String(item.id || ''), String(item.selling_plan || ''), item.properties ? String(item.properties._ia_meal_source || '') : '', item.properties ? String(item.properties._ia_week_build_id || '') : ''].join('|');
  }
  function quantities(cart) {
    var output = {};
    (cart && cart.items ? cart.items : []).forEach(function (item) { var key = cartSignature(item); output[key] = (output[key] || 0) + number(item.quantity, 0); });
    return output;
  }
  function safeJson(value, fallback) { try { return JSON.parse(value); } catch (error) { return fallback; } }

  var SHARED_RULES = {
    'pasture-raised-heritage-ground-pork-2lb': 'One two-pound package can cover Pizza Night and Taco Night at the planned one-pound portions.',
    '🍞-flara-english-muffins-5': 'Each selected meal uses a full muffin package, so the recommendation follows the package count you approved inside each meal.',
    'pasture-raised-bacon-pack': 'One 12-ounce bacon package can cover Breakfast Sandwich Week and Burger Night when portioned across both.',
    'everyday-cheddar-16oz': 'One 16-ounce cheddar package can cover the planned portions for Breakfast Sandwich Week and Burger Night.',
    'grass-fed-meunster-cheese-16oz': 'One 16-ounce Muenster package can cover the planned portions for Breakfast Sandwich Week and Brat Night.',
    'microgreens-rotational-1oz': 'One one-ounce package can be divided as a fresh finish across as many as three selected meals.',
    'organic-lemons': 'One two-pound lemon package can cover both recipes when it returns to the market.',
    'chef-s-herb-bundle': 'The rotating herb bundle can support several meals, but bunch sizes change. Review and approve one shared package.'
  };

  function suppressPopup() {
    if (!document.querySelector('[data-mme-popup-scope]')) return;
    document.documentElement.classList.add('ia-mme-popup-suppressed');
    function hide() {
      document.querySelectorAll('.klaviyo-form,[class*="kl-teaser-"]').forEach(function (node) {
        node.style.setProperty('display', 'none', 'important');
        node.setAttribute('aria-hidden', 'true');
        var ancestor = node.parentElement;
        for (var depth = 0; ancestor && depth < 5; depth += 1, ancestor = ancestor.parentElement) {
          var position = window.getComputedStyle(ancestor).position;
          if (position === 'fixed' || position === 'sticky') {
            ancestor.style.setProperty('display', 'none', 'important');
            ancestor.setAttribute('aria-hidden', 'true');
            break;
          }
        }
      });
    }
    hide();
    window.addEventListener('klaviyoForms', hide);
    [120, 500, 1200, 2500, 5000].forEach(function (delay) { window.setTimeout(hide, delay); });
  }

  function WeekController(root) {
    this.root = root;
    this.currency = root.dataset.currency || 'USD';
    this.orderMinimum = number(root.dataset.orderMinimum, 10000);
    this.deliveryThreshold = number(root.dataset.deliveryThreshold, 15000);
    this.storageKey = root.dataset.storageKey || 'ia_mme_week_v2';
    this.storageHours = number(root.dataset.storageHours, 24);
    this.meals = Array.prototype.slice.call(root.querySelectorAll('[data-mme-week-meal]')).sort(function (a, b) { return number(a.dataset.sortOrder, 999) - number(b.dataset.sortOrder, 999); });
    this.mealGrid = root.querySelector('[data-mme-week-meal-grid]');
    if (this.mealGrid) this.meals.forEach(function (meal) { this.mealGrid.appendChild(meal); }.bind(this));
    this.customizations = root.querySelector('[data-mme-week-customizations]');
    this.customizationPanels = root.querySelector('[data-mme-week-customization-panels]');
    this.moveCustomizationPanels();
    this.review = root.querySelector('[data-mme-week-review]');
    this.selectionGuidance = root.querySelector('[data-mme-week-selection-guidance]');
    this.summary = root.querySelector('[data-mme-week-summary]');
    this.summaryToggle = root.querySelector('[data-mme-week-summary-toggle]');
    this.summaryDetails = root.querySelector('[data-mme-week-summary-details]');
    this.mobileSummary = root.querySelector('[data-mme-week-mobile-summary]');
    this.mobileAction = root.querySelector('[data-mme-week-mobile-action]');
    this.productList = root.querySelector('[data-mme-week-products]');
    this.notices = root.querySelector('[data-mme-week-notices]');
    this.summaryTitle = root.querySelector('[data-mme-week-title]');
    this.summaryCount = root.querySelector('[data-mme-week-count]');
    this.summaryMeals = root.querySelector('[data-mme-week-selected-meals]');
    this.mealCount = root.querySelector('[data-mme-week-meal-count]');
    this.servingCount = root.querySelector('[data-mme-week-serving-count]');
    this.productCount = root.querySelector('[data-mme-week-product-count]');
    this.total = root.querySelector('[data-mme-week-total]');
    this.addButton = root.querySelector('[data-mme-week-add]');
    this.notice = root.querySelector('[data-mme-week-summary-notice]');
    this.live = root.querySelector('[data-mme-week-live]');
    this.recurringOption = root.querySelector('[data-mme-week-recurring-option]');
    this.recurringNote = root.querySelector('[data-mme-week-recurring-note]');
    this.approvals = {};
    this.buildId = 'week-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
    this.pending = false;
    this.started = false;
    this.added = false;
    this.sharedTracked = {};
    this.thresholdReached = { minimum: false, delivery: false };
    this.openMealId = '';
    this.summaryExpanded = false;
    this.returning = false;
    this.restore();
    var handoffId = '';
    try { handoffId = String(new URL(window.location.href).searchParams.get('meal') || '').trim(); } catch (error) {}
    var handoffMeal = this.meals.find(function (meal) { return meal.dataset.mealId === handoffId; });
    if (handoffMeal) {
      handoffMeal.querySelector('[data-mme-week-meal-toggle]').checked = true;
      this.openMealId = handoffId;
      this.approvals = {};
      this.started = true;
    } else {
      var initiallySelectedMeal = this.selectedMeals()[0];
      if (initiallySelectedMeal) this.openMealId = initiallySelectedMeal.dataset.mealId;
    }
    this.bind();
    this.update(handoffMeal ? 'handoff' : 'initial');
    if (handoffMeal) {
      try {
        var cleanUrl = new URL(window.location.href);
        cleanUrl.searchParams.delete('meal');
        window.history.replaceState({}, '', cleanUrl.pathname + cleanUrl.search + cleanUrl.hash);
      } catch (error) {}
      emit('ia_mme_week_handoff_received', { source: 'build-your-week', meal_id: handoffId, meal_count: this.selectedMeals().length });
      window.requestAnimationFrame(function () { handoffMeal.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
    }
  }

  WeekController.prototype.moveCustomizationPanels = function () {
    if (!this.customizationPanels) return;
    var destination = this.customizationPanels;
    this.meals.forEach(function (meal) {
      var panel = meal.querySelector('[data-mme-week-customize]');
      if (panel) destination.appendChild(panel);
    });
  };
  WeekController.prototype.placeCustomizationPanels = function () {
    if (!this.customizationPanels) return;
    var destination = this.customizationPanels;
    this.meals.forEach(function (meal) {
      var panel = this.panelForMeal(meal.dataset.mealId);
      if (panel && panel.parentElement !== destination) destination.appendChild(panel);
    }.bind(this));
  };
  WeekController.prototype.panelForMeal = function (mealId) {
    return Array.prototype.slice.call(this.root.querySelectorAll('[data-mme-week-customize]')).find(function (panel) { return panel.dataset.mealId === mealId; }) || null;
  };
  WeekController.prototype.ingredientsForMeal = function (meal) {
    var mealId = meal && meal.dataset ? meal.dataset.mealId : '';
    return Array.prototype.slice.call(this.root.querySelectorAll('[data-mme-week-ingredient]')).filter(function (item) { return item.dataset.mealId === mealId; });
  };

  WeekController.prototype.itemKey = function (item) {
    return [item.dataset.mealId || '', item.dataset.productHandle || item.dataset.variantId || '0', item.dataset.choiceGroup || '', item.dataset.role || ''].join('|');
  };
  WeekController.prototype.legacyItemKey = function (item) {
    return [item.dataset.mealId || '', item.dataset.variantId || '0', item.dataset.choiceGroup || '', item.dataset.role || ''].join('|');
  };
  WeekController.prototype.applyVariant = function (item, variantId) {
    var select = item && item.querySelector('[data-mme-week-variant-select]');
    if (!select) return;
    if (variantId && Array.prototype.some.call(select.options, function (option) { return option.value === String(variantId) && !option.disabled; })) select.value = String(variantId);
    var option = select.options[select.selectedIndex];
    if (!option) return;
    ['variantId','variantTitle','price','available','sellingPlanId','sellingPlanPrice','imageUrl'].forEach(function (key) {
      item.dataset[key] = option.dataset[key] || '';
    });
    var available = truthy(item.dataset.available);
    item.classList.toggle('is-unavailable', !available);
    var input = item.querySelector('[data-mme-week-choice],[data-mme-week-toggle]');
    if (input) input.disabled = !available;
    var image = item.querySelector('.ia-mme-week-ingredient__choice img');
    if (image && item.dataset.imageUrl) image.src = item.dataset.imageUrl;
    var variantLabel = item.querySelector('[data-mme-week-ingredient-variant]');
    if (variantLabel) {
      variantLabel.textContent = item.dataset.variantTitle && item.dataset.variantTitle.toLowerCase() !== 'default title' ? item.dataset.variantTitle : '';
      variantLabel.hidden = !variantLabel.textContent;
    }
    var price = item.querySelector('[data-mme-week-ingredient-price]');
    if (price) price.textContent = money(number(item.dataset.price, 0), this.currency);
  };
  WeekController.prototype.isItemSelected = function (item) {
    var input = item.querySelector('[data-mme-week-choice],[data-mme-week-toggle]');
    return Boolean(input && input.checked);
  };
  WeekController.prototype.mode = function () {
    var checked = this.root.querySelector('[data-mme-week-purchase-mode] input:checked');
    return checked ? checked.value : 'one_time';
  };
  WeekController.prototype.selectedMeals = function () {
    return this.meals.filter(function (meal) { var toggle = meal.querySelector('[data-mme-week-meal-toggle]'); return Boolean(toggle && toggle.checked); });
  };
  WeekController.prototype.mealServings = function (meal) {
    var toggle = meal && meal.querySelector('[data-mme-week-meal-toggle]');
    if (!toggle || !toggle.checked) return 0;
    var yielded = this.ingredientsForMeal(meal).reduce(function (sum, item) {
      if (!this.isItemSelected(item)) return sum;
      var yieldPerPackage = number(item.dataset.servingsYield, 0);
      return sum + yieldPerPackage * number(item.dataset.quantity, 1);
    }.bind(this), 0);
    return yielded > 0 ? Math.min(yielded, number(meal.dataset.servingsCap, 24)) : number(meal.dataset.servings, 1);
  };
  WeekController.prototype.consolidate = function () {
    var controller = this;
    var selectedMeals = this.selectedMeals();
    var products = {};
    var unavailable = [];
    selectedMeals.forEach(function (meal) {
      controller.ingredientsForMeal(meal).forEach(function (item) {
        if (!controller.isItemSelected(item)) return;
        var variantId = number(item.dataset.variantId, 0);
        if (!variantId) return;
        if (!truthy(item.dataset.available)) { unavailable.push(item.dataset.productTitle || item.dataset.role); return; }
        var key = String(variantId);
        if (!products[key]) {
          products[key] = {
            variantId: variantId,
            variantTitle: item.dataset.variantTitle || '',
            handle: item.dataset.productHandle || '',
            title: item.dataset.productTitle || item.dataset.role || 'Grocery',
            producer: item.dataset.producer || '',
            imageUrl: item.dataset.imageUrl || '',
            price: number(item.dataset.price, 0),
            recurringPrice: number(item.dataset.sellingPlanPrice, 0),
            sellingPlanId: number(item.dataset.sellingPlanId, 0),
            fractions: 0,
            meals: [],
            roles: []
          };
        }
        var line = products[key];
        line.fractions += number(item.dataset.packageFraction, 1000) * number(item.dataset.quantity, 1);
        line.meals.push(item.dataset.mealName || meal.dataset.mealName);
        line.roles.push(item.dataset.role || 'Grocery');
      });
    });
    var lines = Object.keys(products).map(function (key) {
      var line = products[key];
      line.meals = unique(line.meals);
      line.roles = unique(line.roles);
      line.shared = line.meals.length > 1;
      line.recommendedQuantity = Math.max(1, Math.ceil(line.fractions / 1000));
      var existingRow = controller.root.querySelector('[data-mme-week-product-row][data-variant-id="' + key + '"]');
      line.manual = Boolean(existingRow && truthy(existingRow.dataset.manual));
      line.quantity = line.manual ? number(existingRow.dataset.quantity, line.recommendedQuantity) : line.recommendedQuantity;
      line.quantity = Math.max(1, Math.min(8, line.quantity));
      line.approved = !line.shared || number(controller.approvals[key], 0) === line.quantity;
      line.rule = SHARED_RULES[line.handle] || (line.shared ? 'This product appears in more than one selected meal. Review the package quantity before adding your week.' : 'One package is recommended for this selected meal.');
      return line;
    }).sort(function (a, b) { return a.title.localeCompare(b.title); });
    var oneTime = lines.reduce(function (sum, line) { return sum + line.price * line.quantity; }, 0);
    var recurring = lines.reduce(function (sum, line) { return sum + (line.sellingPlanId && line.recurringPrice ? line.recurringPrice : line.price) * line.quantity; }, 0);
    return {
      meals: selectedMeals,
      lines: lines,
      unavailable: unique(unavailable),
      oneTimeTotal: oneTime,
      recurringTotal: recurring,
      recurringEligibleCount: lines.filter(function (line) { return line.sellingPlanId && line.recurringPrice; }).length,
      ineligibleCount: lines.filter(function (line) { return !line.sellingPlanId || !line.recurringPrice; }).length,
      unapproved: lines.filter(function (line) { return line.shared && !line.approved; }),
      servings: selectedMeals.reduce(function (sum, meal) { return sum + controller.mealServings(meal); }, 0)
    };
  };

  WeekController.prototype.renderProducts = function (state) {
    var controller = this;
    this.productList.innerHTML = '';
    state.lines.forEach(function (line) {
      var row = document.createElement('article');
      row.className = 'ia-mme-week-product' + (line.shared ? ' is-shared' : '') + (line.approved ? ' is-approved' : '');
      row.dataset.mmeWeekProductRow = '';
      row.dataset.variantId = String(line.variantId);
      row.dataset.quantity = String(line.quantity);
      var image = line.imageUrl ? '<img src="' + line.imageUrl.replace(/"/g, '&quot;') + '" alt="' + line.title.replace(/"/g, '&quot;').replace(/</g, '&lt;') + '" width="80" height="80">' : '<span class="ia-mme-week-product__image" aria-hidden="true">—</span>';
      var meals = line.meals.map(function (name) { return '<li>' + name.replace(/</g, '&lt;') + '</li>'; }).join('');
      var approval = line.shared ? '<label class="ia-mme-week-product__approval"><input type="checkbox" data-mme-week-approve ' + (line.approved ? 'checked' : '') + '><span>I approve ' + line.quantity + ' ' + (line.quantity === 1 ? 'package' : 'packages') + ' for these meals.</span></label>' : '';
      var variantLabel = line.variantTitle && line.variantTitle.toLowerCase() !== 'default title' ? '<small class="ia-mme-week-product__variant">' + line.variantTitle.replace(/</g, '&lt;') + '</small>' : '';
      row.innerHTML = image + '<div class="ia-mme-week-product__meta"><span class="ia-mme-week-product__badge">' + (line.shared ? 'Shared across meals' : 'One meal') + '</span><strong>' + line.title.replace(/</g, '&lt;') + '</strong>' + variantLabel + (line.producer ? '<small>From ' + line.producer.replace(/</g, '&lt;') + '</small>' : '') + '<p>' + line.rule.replace(/</g, '&lt;') + '</p><ul aria-label="Used by">' + meals + '</ul>' + approval + '</div><div class="ia-mme-week-product__controls"><strong data-mme-week-line-total>' + money((controller.mode() === 'recurring' && line.sellingPlanId && line.recurringPrice ? line.recurringPrice : line.price) * line.quantity, controller.currency) + '</strong><div class="ia-mme-week-quantity"><button type="button" data-mme-week-product-decrease aria-label="Decrease ' + line.title.replace(/"/g, '&quot;') + ' quantity">−</button><output data-mme-week-product-quantity>' + line.quantity + '</output><button type="button" data-mme-week-product-increase aria-label="Increase ' + line.title.replace(/"/g, '&quot;') + ' quantity">+</button></div></div>';
      controller.productList.appendChild(row);
      if (line.shared && !controller.sharedTracked[line.variantId]) {
        controller.sharedTracked[line.variantId] = true;
        emit('ia_mme_shared_product_detected', { source: 'build-your-week', variant_id: line.variantId, product_handle: line.handle, meal_ids: line.meals, recommended_quantity: line.recommendedQuantity });
      }
    });
  };

  WeekController.prototype.renderThreshold = function (kind, total) {
    var threshold = kind === 'minimum' ? this.orderMinimum : this.deliveryThreshold;
    var row = this.root.querySelector('[data-mme-week-threshold="' + kind + '"]');
    if (!row || !threshold) return;
    var gap = Math.max(0, threshold - total);
    var text = row.querySelector('[data-mme-week-threshold-text]');
    var bar = row.querySelector('[data-mme-week-threshold-bar]');
    if (kind === 'minimum') text.textContent = gap ? money(gap, this.currency) + ' to go' : 'Minimum reached';
    else text.textContent = gap ? money(gap, this.currency) + ' to go' : 'Complimentary delivery reached';
    row.classList.toggle('is-reached', gap === 0);
    if (bar) bar.style.width = Math.min(100, total / threshold * 100) + '%';
    if (gap === 0 && !this.thresholdReached[kind]) {
      this.thresholdReached[kind] = true;
      emit('ia_mme_threshold_reached', { source: 'build-your-week', threshold: kind, threshold_cents: threshold, selected_value_cents: total });
    }
    if (gap > 0) this.thresholdReached[kind] = false;
  };

  WeekController.prototype.updateMealCards = function () {
    var controller = this;
    this.meals.forEach(function (meal) {
      var total = 0;
      controller.ingredientsForMeal(meal).forEach(function (item) {
        var itemSelected = controller.isItemSelected(item);
        item.classList.toggle('is-selected', itemSelected);
        if (!itemSelected || !number(item.dataset.variantId, 0) || !truthy(item.dataset.available)) return;
        total += number(item.dataset.price, 0) * number(item.dataset.quantity, 1);
      });
      var toggle = meal.querySelector('[data-mme-week-meal-toggle]');
      var selected = Boolean(toggle && toggle.checked);
      var open = selected && controller.openMealId === meal.dataset.mealId;
      var displayServings = selected ? Math.max(1, controller.mealServings(meal)) : Math.max(1, number(meal.dataset.servings, 1));
      var node = meal.querySelector('[data-mme-week-meal-total]');
      if (node) node.textContent = money(total, controller.currency) + ' total';
      var perPerson = meal.querySelector('[data-mme-week-meal-per-person]');
      if (perPerson) perPerson.textContent = 'About ' + money(Math.round(total / displayServings), controller.currency) + ' per person';
      meal.classList.toggle('is-selected', selected);
      toggle.disabled = false;
      var toggleLabel = toggle.closest('.ia-mme-week-meal__toggle');
      if (toggleLabel) toggleLabel.title = selected ? 'Remove ' + meal.dataset.mealName : 'Select ' + meal.dataset.mealName;
      var selectionLabel = meal.querySelector('[data-mme-week-select-label]');
      if (selectionLabel) selectionLabel.textContent = selected ? 'Selected — Remove' : 'Select This Meal';
      var panel = controller.panelForMeal(meal.dataset.mealId);
      if (!panel) return;
      panel.hidden = !selected;
      panel.classList.toggle('is-open', open);
      var panelToggle = panel.querySelector('[data-mme-week-customize-toggle]');
      var panelContent = panel.querySelector('[data-mme-week-customize-content]');
      var panelLabel = panel.querySelector('[data-mme-week-customize-label]');
      var panelServings = panel.querySelector('[data-mme-week-customize-servings]');
      var panelTotal = panel.querySelector('[data-mme-week-customize-total]');
      if (panelToggle) panelToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (panelContent) panelContent.hidden = !open;
      if (panelLabel) panelLabel.firstChild.nodeValue = open ? 'Hide ingredients ' : 'Customize ingredients ';
      if (panelServings) panelServings.textContent = displayServings + (displayServings === 1 ? ' serving' : ' servings');
      if (panelTotal) panelTotal.textContent = money(total, controller.currency);
    });
  };

  WeekController.prototype.update = function (reason) {
    this.updateMealCards();
    this.placeCustomizationPanels();
    var state = this.consolidate();
    var mode = this.mode();
    var activeTotal = mode === 'recurring' ? state.recurringTotal : state.oneTimeTotal;
    if (this.customizations) this.customizations.hidden = state.meals.length === 0;
    this.review.hidden = state.meals.length === 0;
    if (this.selectionGuidance) this.selectionGuidance.textContent = state.meals.length ? state.meals.length + (state.meals.length === 1 ? ' meal selected. Customize it below or choose another.' : ' meals selected. Customize them below or choose another.') : 'Compare all nine meals, then select any that fit your table. Every grocery remains editable.';
    this.summaryTitle.textContent = state.meals.length ? ((reason === 'initial' && this.returning) ? 'Continue Your Week' : (state.meals.length === 1 ? 'Your meal is taking shape' : 'Your week is taking shape')) : 'Choose a meal to get started';
    this.summaryCount.textContent = state.meals.length ? state.meals.length + (state.meals.length === 1 ? ' meal selected' : ' meals selected') : 'No meals selected';
    this.summaryMeals.innerHTML = '';
    state.meals.forEach(function (meal) { var line = document.createElement('li'); line.textContent = meal.dataset.mealName; this.summaryMeals.appendChild(line); }.bind(this));
    this.mealCount.textContent = String(state.meals.length);
    this.servingCount.textContent = String(state.servings);
    this.productCount.textContent = String(state.lines.length);
    this.total.textContent = money(activeTotal, this.currency);
    if (this.mobileSummary) this.mobileSummary.textContent = state.meals.length ? state.meals.length + (state.meals.length === 1 ? ' meal' : ' meals') + ' · ' + state.servings + (state.servings === 1 ? ' serving' : ' servings') + ' · ' + money(activeTotal, this.currency) : 'No meals selected';
    if (!state.meals.length) this.summaryExpanded = false;
    if (this.summary) {
      this.summary.classList.toggle('has-selection', state.meals.length > 0);
      this.summary.classList.toggle('is-expanded', this.summaryExpanded && state.meals.length > 0);
    }
    if (this.summaryToggle) this.summaryToggle.setAttribute('aria-expanded', this.summaryExpanded && state.meals.length > 0 ? 'true' : 'false');
    if (this.mobileAction) this.mobileAction.textContent = this.summaryExpanded ? 'Close summary ↑' : 'Review My Week →';
    this.renderProducts(state);
    this.renderThreshold('minimum', activeTotal);
    this.renderThreshold('delivery', activeTotal);

    var recurringRadio = this.recurringOption.querySelector('input');
    var hasRecurring = state.recurringEligibleCount > 0;
    this.recurringOption.hidden = !hasRecurring;
    this.recurringNote.textContent = hasRecurring ? (state.ineligibleCount ? state.ineligibleCount + ' selected ' + (state.ineligibleCount === 1 ? 'product stays' : 'products stay') + ' one-time because no recurring option is available.' : 'All selected groceries are eligible at their current recurring prices.') : 'No selected groceries currently offer recurring delivery.';
    if (!hasRecurring && recurringRadio.checked) this.root.querySelector('[data-mme-week-purchase-mode] input[value="one_time"]').checked = true;

    var messages = [];
    if (state.unavailable.length) messages.push('Unavailable and excluded: ' + state.unavailable.join(', ') + '.');
    if (state.unapproved.length) messages.push('Approve ' + state.unapproved.length + ' shared ' + (state.unapproved.length === 1 ? 'quantity' : 'quantities') + ' before adding your week.');
    this.notices.innerHTML = messages.map(function (message) { return '<p>' + message.replace(/</g, '&lt;') + '</p>'; }).join('');
    var minimumGap = Math.max(0, this.orderMinimum - activeTotal);
    if (reason !== 'complete') {
      if (state.meals.length === 0) this.notice.textContent = 'Choose a meal to get started.';
      else if (state.unapproved.length) this.notice.textContent = 'Review and approve every shared product quantity.';
      else if (state.unavailable.length) this.notice.textContent = 'Remove or replace unavailable groceries before adding to cart.';
      else if (minimumGap > 0) this.notice.textContent = 'Add ' + money(minimumGap, this.currency) + ' more to reach the order minimum.';
      else this.notice.textContent = '';
      this.notice.classList.toggle('is-visible', Boolean(this.notice.textContent));
    }
    this.addButton.disabled = this.pending || state.meals.length === 0 || !state.lines.length || state.unapproved.length > 0 || state.unavailable.length > 0 || minimumGap > 0;
    var addLabel = state.meals.length === 1 ? 'Add This Meal to Cart' : 'Add My Week to Cart';
    this.addButton.textContent = this.pending ? 'Adding…' : addLabel + ' · ' + money(activeTotal, this.currency);
    this.persist();
    return state;
  };

  WeekController.prototype.clearApprovals = function () { this.approvals = {}; };
  WeekController.prototype.bind = function () {
    var controller = this;
    this.root.addEventListener('change', function (event) {
      if (event.target.matches('[data-mme-week-meal-toggle]')) {
        var selected = event.target.checked;
        var meal = event.target.closest('[data-mme-week-meal]');
        controller.clearApprovals();
        if (selected && !controller.started) { controller.started = true; emit('ia_mme_week_started', { source: 'meals-made-easy' }); }
        if (selected) controller.openMealId = meal.dataset.mealId;
        else if (controller.openMealId === meal.dataset.mealId) {
          var nextSelected = controller.selectedMeals()[0];
          controller.openMealId = nextSelected ? nextSelected.dataset.mealId : '';
        }
        emit('ia_mme_week_meal_toggled', { source: 'meals-made-easy', meal_id: meal.dataset.mealId, selected: selected, meal_count: controller.selectedMeals().length });
        controller.update('meal');
        controller.announce(meal.dataset.mealName + (selected ? ' selected.' : ' removed.'));
        return;
      }
      if (event.target.matches('[data-mme-week-variant-select]')) {
        var variantItem = event.target.closest('[data-mme-week-ingredient]');
        controller.applyVariant(variantItem);
        controller.clearApprovals();
        emit('ia_meal_bundle_selection_changed', { version: 2, source: 'build-your-week', meal_id: variantItem.dataset.mealId, role: variantItem.dataset.role, action: 'variant_selected', variant_id: number(variantItem.dataset.variantId, 0) });
        controller.update('variant');
        return;
      }
      if (event.target.matches('[data-mme-week-choice],[data-mme-week-toggle]')) {
        controller.clearApprovals();
        var item = event.target.closest('[data-mme-week-ingredient]');
        item.classList.toggle('is-selected', event.target.checked);
        emit('ia_meal_bundle_selection_changed', { version: 2, source: 'build-your-week', meal_id: item.dataset.mealId, role: item.dataset.role, selected: event.target.checked, variant_id: number(item.dataset.variantId, 0) });
        controller.update('ingredient');
        return;
      }
      if (event.target.matches('[data-mme-week-approve]')) {
        var row = event.target.closest('[data-mme-week-product-row]');
        controller.approvals[row.dataset.variantId] = event.target.checked ? number(row.dataset.quantity, 1) : 0;
        emit('ia_mme_shared_quantity_approved', { source: 'build-your-week', variant_id: number(row.dataset.variantId, 0), quantity: number(row.dataset.quantity, 1), approved: event.target.checked });
        controller.update('approval');
        return;
      }
      if (event.target.closest('[data-mme-week-purchase-mode]')) {
        controller.update('mode');
      }
    });
    this.root.addEventListener('click', function (event) {
      var recipeToggle = event.target.closest('[data-mme-week-recipe-toggle]');
      if (recipeToggle) {
        event.preventDefault();
        var recipeMeal = recipeToggle.closest('[data-mme-week-meal]');
        var recipeInput = recipeMeal && recipeMeal.querySelector('[data-mme-week-meal-toggle]');
        if (!recipeMeal || !recipeInput) return;
        if (!recipeInput.checked) {
          recipeInput.checked = true;
          controller.started = true;
          controller.clearApprovals();
          emit('ia_mme_week_meal_toggled', { source: 'recipe-expand', meal_id: recipeMeal.dataset.mealId, selected: true, meal_count: controller.selectedMeals().length });
        }
        controller.openMealId = recipeMeal.dataset.mealId;
        controller.update('recipe_expand');
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            var openedPanel = controller.root.querySelector('[data-mme-week-customize][data-meal-id="' + CSS.escape(recipeMeal.dataset.mealId) + '"]');
            if (!openedPanel || openedPanel.hidden) return;
            var panelRect = openedPanel.getBoundingClientRect();
            var offset = window.matchMedia('(max-width: 749px)').matches ? 88 : 118;
            window.scrollTo({ top: Math.max(0, window.scrollY + panelRect.top - offset), behavior: 'smooth' });
          });
        });
        controller.announce(recipeMeal.dataset.mealName + ' recipe ingredients opened.');
        return;
      }
      var customizeToggle = event.target.closest('[data-mme-week-customize-toggle]');
      if (customizeToggle) {
        var panel = customizeToggle.closest('[data-mme-week-customize]');
        var willOpen = controller.openMealId !== panel.dataset.mealId;
        controller.openMealId = willOpen ? panel.dataset.mealId : '';
        controller.updateMealCards();
        controller.announce(panel.dataset.mealName + (willOpen ? ' customization opened.' : ' customization closed.'));
        return;
      }
      var summaryToggle = event.target.closest('[data-mme-week-summary-toggle]');
      if (summaryToggle) {
        controller.summaryExpanded = !controller.summaryExpanded;
        controller.update('summary_toggle');
        return;
      }
      var ingredientIncrease = event.target.closest('[data-mme-week-ingredient-increase]');
      var ingredientDecrease = event.target.closest('[data-mme-week-ingredient-decrease]');
      if (ingredientIncrease || ingredientDecrease) {
        var ingredient = event.target.closest('[data-mme-week-ingredient]');
        var input = ingredient.querySelector('[data-mme-week-choice],[data-mme-week-toggle]');
        var current = number(ingredient.dataset.quantity, 1);
        var maximum = Math.max(1, number(ingredient.dataset.maxQuantity, 1));
        var next = Math.max(1, Math.min(maximum, current + (ingredientIncrease ? 1 : -1)));
        ingredient.dataset.quantity = String(next);
        var output = ingredient.querySelector('[data-mme-week-ingredient-quantity]');
        if (output) output.textContent = String(next);
        if (input && !input.disabled && !input.checked) input.click();
        controller.clearApprovals();
        emit('ia_mme_quantity_changed', { source: 'build-your-week', meal_id: ingredient.dataset.mealId, variant_id: number(ingredient.dataset.variantId, 0), quantity: next, placement: 'meal_customization' });
        controller.update('ingredient_quantity');
        return;
      }
      var increase = event.target.closest('[data-mme-week-product-increase]');
      var decrease = event.target.closest('[data-mme-week-product-decrease]');
      if (increase || decrease) {
        var row = event.target.closest('[data-mme-week-product-row]');
        var value = number(row.dataset.quantity, 1) + (increase ? 1 : -1);
        row.dataset.quantity = String(Math.max(1, Math.min(8, value)));
        controller.approvals[row.dataset.variantId] = 0;
        emit('ia_mme_quantity_changed', { source: 'build-your-week', variant_id: number(row.dataset.variantId, 0), quantity: number(row.dataset.quantity, 1) });
        controller.update('product_quantity');
        return;
      }
      if (event.target.closest('[data-mme-week-reset]')) { controller.reset(); return; }
      if (event.target.closest('[data-mme-week-add]')) controller.add();
    });
    window.addEventListener('pagehide', function () {
      if (controller.started && !controller.added) {
        var state = controller.consolidate();
        emit('ia_mme_week_abandoned', { source: 'build-your-week', meal_ids: state.meals.map(function (meal) { return meal.dataset.mealId; }), meal_count: state.meals.length, selected_value_cents: controller.mode() === 'recurring' ? state.recurringTotal : state.oneTimeTotal });
      }
    }, { once: true });
  };

  WeekController.prototype.persist = function () {
    var state = {
      expiresAt: Date.now() + this.storageHours * 60 * 60 * 1000,
      buildId: this.buildId,
      meals: this.selectedMeals().map(function (meal) { return meal.dataset.mealId; }),
      items: {}, approvals: this.approvals, mode: this.mode()
    };
    var controller = this;
    this.root.querySelectorAll('[data-mme-week-ingredient]').forEach(function (item) {
      state.items[controller.itemKey(item)] = { selected: controller.isItemSelected(item), quantity: number(item.dataset.quantity, 1), variantId: number(item.dataset.variantId, 0) };
    });
    try { localStorage.setItem(this.storageKey, JSON.stringify(state)); } catch (error) {}
    document.dispatchEvent(new CustomEvent('ia_mme_week_state_changed', { detail: state }));
  };
  WeekController.prototype.restore = function () {
    var saved = null;
    try { saved = safeJson(localStorage.getItem(this.storageKey), null); } catch (error) {}
    if (!saved || number(saved.expiresAt, 0) < Date.now()) return;
    this.buildId = saved.buildId || this.buildId;
    this.approvals = saved.approvals || {};
    this.meals.forEach(function (meal) {
      var selected = (saved.meals || []).indexOf(meal.dataset.mealId) !== -1;
      meal.querySelector('[data-mme-week-meal-toggle]').checked = selected;
    });
    var controller = this;
    this.root.querySelectorAll('[data-mme-week-ingredient]').forEach(function (item) {
      var record = saved.items && (saved.items[controller.itemKey(item)] || saved.items[controller.legacyItemKey(item)]);
      if (!record) return;
      controller.applyVariant(item, record.variantId);
      var input = item.querySelector('[data-mme-week-choice],[data-mme-week-toggle]');
      if (input && !input.disabled) input.checked = Boolean(record.selected);
      item.dataset.quantity = String(Math.max(1, number(record.quantity, 1)));
      var quantityOutput = item.querySelector('[data-mme-week-ingredient-quantity]');
      if (quantityOutput) quantityOutput.textContent = item.dataset.quantity;
    });
    var mode = this.root.querySelector('[data-mme-week-purchase-mode] input[value="' + (saved.mode || 'one_time') + '"]');
    if (mode) mode.checked = true;
    this.started = Boolean((saved.meals || []).length);
    this.returning = this.started;
  };
  WeekController.prototype.reset = function () {
    this.meals.forEach(function (meal) {
      meal.querySelector('[data-mme-week-meal-toggle]').checked = false;
      this.ingredientsForMeal(meal).forEach(function (item) {
        this.applyVariant(item, item.dataset.defaultVariantId);
        var input = item.querySelector('[data-mme-week-choice],[data-mme-week-toggle]');
        if (input) input.checked = truthy(item.dataset.defaultSelected);
        item.dataset.quantity = item.dataset.defaultQuantity || '1';
        var quantityOutput = item.querySelector('[data-mme-week-ingredient-quantity]');
        if (quantityOutput) quantityOutput.textContent = item.dataset.quantity;
      }.bind(this));
    }.bind(this));
    this.approvals = {};
    this.openMealId = '';
    this.summaryExpanded = false;
    this.returning = false;
    this.added = false;
    this.started = false;
    this.buildId = 'week-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8);
    this.root.querySelector('[data-mme-week-purchase-mode] input[value="one_time"]').checked = true;
    this.update('reset');
    try { localStorage.removeItem(this.storageKey); } catch (error) {}
    document.dispatchEvent(new CustomEvent('ia_mme_week_state_changed', { detail: { meals: [], items: {}, approvals: {}, mode: 'one_time' } }));
    this.announce('Your week has been reset.');
  };
  WeekController.prototype.announce = function (message) { if (this.live) this.live.textContent = message; };

  WeekController.prototype.add = function () {
    var controller = this;
    var state = this.update('pre_add');
    if (this.addButton.disabled) return;
    var mode = this.mode();
    var mealIds = state.meals.map(function (meal) { return meal.dataset.mealId; });
    var mealNames = state.meals.map(function (meal) { return meal.dataset.mealName; });
    var items = state.lines.map(function (line) {
      var item = {
        id: line.variantId,
        quantity: line.quantity,
        properties: {
          _ia_meal_bundle_id: 'build-your-week',
          _ia_meal_bundle_name: 'Build Your Week',
          _ia_meal_bundle_role: 'Consolidated grocery',
          _ia_meal_product_title: line.title + (line.variantTitle && line.variantTitle.toLowerCase() !== 'default title' ? ' — ' + line.variantTitle : ''),
          _ia_meal_source: 'build-your-week',
          _ia_week_meal_ids: JSON.stringify(mealIds),
          _ia_week_meal_names: JSON.stringify(mealNames),
          _ia_week_product_meals: JSON.stringify(line.meals),
          _ia_week_build_id: controller.buildId
        }
      };
      if (mode === 'recurring' && line.sellingPlanId && line.recurringPrice) item.selling_plan = line.sellingPlanId;
      return item;
    });
    var expected = mode === 'recurring' ? state.recurringTotal : state.oneTimeTotal;
    this.pending = true;
    this.update('pending');
    emit('ia_mme_week_add_started', { source: 'build-your-week', meal_ids: mealIds, meal_count: mealIds.length, unique_product_count: items.length, purchase_mode: mode, selected_value_cents: expected });
    var before;
    fetchCart().then(function (cart) {
      before = cart;
      return fetch(ROOT_URL + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname }) });
    }).then(parseResponse).then(function (result) {
      return fetchCart().then(function (after) { return { after: after, response: result.data, ok: result.response.ok }; });
    }).then(function (outcome) {
      var beforeQty = quantities(before), afterQty = quantities(outcome.after), missing = [], addedCount = 0;
      items.forEach(function (item) {
        var added = Math.max(0, (afterQty[requestSignature(item)] || 0) - (beforeQty[requestSignature(item)] || 0));
        addedCount += Math.min(added, item.quantity);
        if (added < item.quantity) missing.push(item.id);
      });
      if (missing.length) {
        if (addedCount > 0) {
          var missingNames = state.lines.filter(function (line) { return missing.indexOf(line.variantId) !== -1; }).map(function (line) { return line.title; });
          controller.added = true;
          controller.notice.textContent = 'Added ' + addedCount + ' of ' + items.length + ' products. Could not add: ' + missingNames.join(', ') + '. Review your cart before continuing.';
          controller.notice.classList.add('is-visible');
          controller.announce(controller.notice.textContent);
          emit('ia_mme_week_add_failed', { source: 'build-your-week', meal_ids: mealIds, meal_count: mealIds.length, purchase_mode: mode, selected_value_cents: expected, error_type: 'partial_add', added_product_count: addedCount, missing_variant_ids: missing });
          return;
        }
        throw new Error(outcome.response.description || outcome.response.message || 'The selected groceries could not be added. Please try again.');
      }
      controller.added = true;
      controller.notice.textContent = state.meals.length === 1 ? 'Your meal was added as ' + items.length + ' individual products.' : 'Your week was added as ' + items.length + ' individual products.';
      controller.notice.classList.add('is-visible');
      controller.announce(controller.notice.textContent);
      emit('ia_mme_week_add_to_cart', { source: 'build-your-week', meal_ids: mealIds, meal_count: mealIds.length, unique_product_count: items.length, purchase_mode: mode, selected_value_cents: expected });
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function' && outcome.response.sections) { drawer.classList.remove('is-empty'); drawer.renderContents({ sections: outcome.response.sections }); }
    }).catch(function (error) {
      controller.notice.textContent = error.message || 'The week could not be added. Please try again.';
      controller.notice.classList.add('is-visible');
      controller.announce(controller.notice.textContent);
      emit('ia_mme_week_add_failed', { source: 'build-your-week', meal_ids: mealIds, meal_count: mealIds.length, purchase_mode: mode, selected_value_cents: expected, error_type: 'cart_error' });
    }).finally(function () { controller.pending = false; controller.update('complete'); });
  };

  suppressPopup();
  document.querySelectorAll('[data-mme-week-controller]').forEach(function (root) { if (!root.__iaMmeWeek) root.__iaMmeWeek = new WeekController(root); });
})();
